import React from 'react';
import { useTranslation } from 'react-i18next';

import { Form } from 'react-final-form';
import { Button, Box, FinalFormInput } from '@utex/ui-kit';
import { createValidator, max, min, required, float } from '@unitedtraders/validators';
import { Layout } from '../../../components/Layout';
import { useAppConfig } from '../../../hooks/useAppConfig';
import { UtexBalance } from '../UtexBalance';
import { useSubmit } from './useSubmit';
import { button } from './styles';
import { normalize } from './normalizer';
import { ContentProps } from '../../../types/common';
import { useUtexBalance } from './useUtexBalance';

export interface FormValues {
  amount: number;
}

export const Content: React.FC<ContentProps> = ({ available }) => {
  const { t } = useTranslation('byUtex');
  const { balance } = useUtexBalance();
  const { maximum, minimum } = available[0].parameters;

  const limit = balance ? Math.min(+balance.value, maximum) : maximum;
  const { onSubmit } = useSubmit();

  const { utexWallet } = useAppConfig();

  const validate = createValidator({
    amount: [required(), float(), min(minimum), max(limit)],
  });

  return (
    <Form<FormValues>
      onSubmit={onSubmit}
      validate={validate}
      render={(form) => {
        return (
          <Layout.Form onSubmit={form.handleSubmit} noValidate>
            <Layout.FormContent>
              <Box display="flex" flexDirection="column">
                <FinalFormInput
                  name="amount"
                  id="amount"
                  type="number"
                  inputMode="decimal"
                  allowedSymbols={/\d|\.|\,/g}
                  label="$"
                  isLabelShort
                  placeholder="0"
                  view="big"
                  hintPosition="right"
                  parse={normalize({ max: limit })}
                  caption={<UtexBalance />}
                />
                <Button
                  css={button}
                  href={utexWallet?.url || 'https://utex.io/wallets'}
                  target="_blank"
                  rel="nofollow"
                  size="S"
                  view="extra-dim"
                  shape="round"
                >
                  {t('Deposit UTEX account')}
                </Button>
              </Box>
            </Layout.FormContent>

            <Layout.FormFooter>
              <Button view="alert" type="submit">
                {t('Confirm transfer')}
              </Button>
            </Layout.FormFooter>
          </Layout.Form>
        );
      }}
    />
  );
};
